export enum SubscriptionState {
  None = 0,
  SubscriptionsLoading = 1 << 0,
  Initialized = 1 << 1,
  CreatingTrialAccount = 1 << 2,
}
